import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function Channel() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit channel` : 'Add channel'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const getInitialChannelData = () => ({
        channel_type: '',
        code: '',
        channel: '',
        calleridname: '',
        calleridnum: '',
        name: '',
        asteriskip: '',
        currentaon: '',
        maxcallspersecond: ''
    })

    //Get user
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/channel/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setChannelData({ ...getInitialChannelData(), ...response.data[0] })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/channel`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/channel/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [channelData, setChannelData] = useState<any>(getInitialChannelData())


    //On load if URL params contains type=edit
    useEffect(() => {
        type === 'edit' && fetchData()
        console.log(channelData);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 500, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, code: e.target.value !== '' ? e.target.value : null })} value={channelData.code || ''} variant="outlined" size="small" label='Channel Code*' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, channel: e.target.value !== '' ? e.target.value : null })} value={channelData.channel || ''} variant="outlined" size="small" label='Channel*' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, name: e.target.value !== '' ? e.target.value : null })} value={channelData.name || ''} variant="outlined" size="small" label='Name*' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, asteriskip: e.target.value !== '' ? e.target.value : null })} value={channelData.asteriskip || ''} variant="outlined" size="small" label='Asterisk IP*' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, channel_type: e.target.value !== '' ? e.target.value : null })} value={channelData.channel_type || ''} variant="outlined" size="small" label='Channel Type' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, calleridname: e.target.value !== '' ? e.target.value : null })} value={channelData.calleridname || ''} variant="outlined" size="small" label='Caller ID Name' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, calleridnum: e.target.value !== '' ? e.target.value : null })} value={channelData.calleridnum || ''} variant="outlined" size="small" label='Caller ID Number' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, currentaon: e.target.value !== '' ? e.target.value : null })} value={channelData.currentaon || ''} variant="outlined" size="small" label='Current AON' />
                    <TextField sx={{width: '100%'}} onChange={(e) => setChannelData({ ...channelData, maxcallspersecond: e.target.value !== '' ? e.target.value : null })} value={channelData.maxcallspersecond || ''} variant="outlined" size="small" label='Max Calls Per Second' />
                </Box>
                <Button onClick={() => type === "edit" ? putData(channelData) : postData(channelData)} variant="contained" sx={{ width: "100%" }}>Save</Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/channels' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}